
import { useState, useEffect } from 'react'
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddCompetency } from "./Modal/AddCompetency";
import { CompetencyList } from "../Common/CompetencyList"
import Swal from 'sweetalert2'
import axios from 'axios'
import { AdminCompetencyList } from '../Common/AdminCompetencyList';
import { IconButton, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';

export default function Competency() {
    const authUser = localStorage.getItem("FF-authUser");
    const role = JSON.parse(authUser).role;
    const [show, setShow] = useState(false);
    const [popupType, setPopupType] = useState("Add");
    const [editId, setEditId] = useState(0);
    const [competencies, setCompetencies] = useState([]);
    const [teamId, setTeamId] = useState(0);
    
    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        console.log("Updated teamId", teamId)
    }, [teamId])

    const handleAdd = (teamId) => {
        setTeamId(teamId)
        setEditId(0);
        setPopupType('Add');
        setShow(true);
    }

    const getList = async () => {
        let apiUrl = "/api/admin_competencies";

        await axios.get(apiUrl).then(function (response) {
            let result = response.data;
            if (result.success) {
                setCompetencies(result.data);
            } else {
                // Handle error or set isError state if needed.
            }
        });
    };

    const [accordion, setAccordion] = useState({});
    const [isChange, setIsChange] = useState(false);
    const handleAccordionChange = (key) => {
        console.log("key", key)
        if(accordion && accordion[key]){
            accordion[key] = !accordion[key]
        }
        else{
            accordion[key] = true
        }
        setIsChange((prev) => !prev);
        // Get the accordion button element
        const accordionButton = document.querySelector(`[data-key="${key}"]`);
        console.log("accordionButton",accordionButton)
        // Toggle the active class on the accordion button
        accordionButton.classList.toggle('active');
    }
    return(
        <Layout>
            <Header pageTitle={'Competencies'} />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="">
                    <div className="card-header d-flex justify-content-between align-items-center">                      
                        <h3 className="fw-bold mb-0">Competencies</h3>
                        {/* <button type="button" onClick={() => handleAdd()} className="btn btn-primary">
                            <span className="tf-icons bx bx-plus"></span>&nbsp; Add Competency
                        </button> */}
                    </div>

                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                            <div className="col-md mb-4 mb-md-0">
                                <div className="accordion" id="accordionExample1">
                                    {competencies.map((competency) => (
                                        <div className="card accordion-item" key={competency.teamId}>
                                            <h2 className="accordion-header d-flex align-items-center" id="headingOne">
                                                <button type="button" onClick={() => handleAccordionChange("accordionn1"+competency.teamId)} className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target={"#accordionn1"+competency.teamId} aria-expanded="false" aria-controls={"accordionn1"+competency.teamId}  data-key={"accordionn1"+competency.teamId}>
                                                    <b>{competency.name}</b>
                                                </button>
                                                <div className="d-flex align-items-center">
                                                    <Tooltip title="Add Competency" size='small' className='icon icon-sm icon-theme me-3' onClick={() => handleAdd(competency.teamId)}>
                                                        <IconButton>
                                                            <Add />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </h2>

                                            <div id={"accordionn1"+competency.teamId} className={accordion && accordion["accordionn1"+competency.teamId] ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <div className="table-responsive">

                                                        <AdminCompetencyList competencies={competency.competencies} getList={getList} userId={competency.teamId}/>
                                            
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {show && (
                <AddCompetency
                    type={popupType}
                    show={show}
                    setShow={setShow}
                    getList={getList}
                    editId={editId}
                    setEditId={setEditId}
                    userId={0}
                    teamId={teamId}
                />
            )}
        </Layout>
    )
}